/**
 * @param {(Array)} arr
 * @return {Array}
 */
//不处理根组织
export function handleTree(arr) {
  let data = arr;
  data.forEach(el => {
    if (!el.subUnit.length) {
      el.children = undefined;
    } else {
      el.children = el.subUnit;
      el.children.forEach(el2 => {
        if (!el2.subUnit.length) {
          el2.children = undefined;
        } else {
          [(el2.children = el2.subUnit)];
        }
      });
    }
  });
  return data;
}

/**
 * @param {(Array)} arr
 * @return {Array}
 */
//不处理根组织
export function handleEditTree(arr) {
  let data = [];
  if (arr.length == 3) {
    data = arr.slice(-1);
  }
  if (arr.length == 4) {
    data = arr.slice(-2);
  }
  return data;
}
/** 获取cookie */
export const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1){
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// 设置cookie
export const  setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
 d.setTime(d.getTime() + (exdays*24*60*60*1000));
 var expires = ";expires="+  d.toUTCString();
 console.log('设置cookie')
 document.cookie = cname + "=" + cvalue + expires + ';Path=/';
 console.log('cookie设置成功1')
}
// 清除cookie
export const clearAllCookie = () => {
  var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/q'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/weChatPublicMsgLink'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/qrCode'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/geAction'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/ql'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/getLoginStatus'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/getWechatPublicAuthorizationUrl'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/getReplyMessageAction'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/getCallBackDomain'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/weChatPublicAuthLogin'
       document.cookie=keys[i]+'=;expires=' + new Date( 0).toUTCString() + ';Path=/getRedirectParam'


    }
  }
}

